import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {EventService} from '../api/event-api.service';
import {SpinnerService} from '../shared/services/spinner.service';
import {finalize} from 'rxjs';

@Component({
    selector: 'app-event-public',
    templateUrl: './event-public.component.html',
    styleUrls: ['./event-public.component.css']
})
export class EventPublicComponent implements OnInit {

    eventId: string = '';
    eventTitle: string = '';
    eventCategory: string = '';
    activeTab: 'registration' | 'attendees' = 'registration';

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private eventService: EventService,
        private spinner: SpinnerService
    ) {}

    ngOnInit(): void {
        this.route.paramMap.subscribe(params => {
            this.eventId = params.get('id') || '';
            if (this.eventId) {
                if (sessionStorage.getItem('username')) {
                    this.router.navigate(['/event-home', this.eventId]);
                    return;
                }
                this.loadEventTitle();
            }
        });
    }

    private loadEventTitle(): void {
        this.spinner.show();
        this.eventService.getPublicEventDetails(this.eventId).pipe(
            finalize(() => this.spinner.hide())
        ).subscribe({
            next: (event) => { this.eventTitle = event.title || ''; this.eventCategory = event.eventCategory || ''; },
            error: () => {}
        });
    }

    setTab(tab: 'registration' | 'attendees'): void {
        this.activeTab = tab;
    }

    onTabKeydown(event: KeyboardEvent, current: 'registration' | 'attendees'): void {
        const tabs: ('registration' | 'attendees')[] = ['registration', 'attendees'];
        const idx = tabs.indexOf(current);
        let next = idx;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
            next = (idx + 1) % tabs.length;
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
            next = (idx - 1 + tabs.length) % tabs.length;
        }
        if (next !== idx) {
            this.setTab(tabs[next]);
            (event.currentTarget as HTMLElement)
                .closest('[role="tablist"]')
                ?.querySelectorAll<HTMLElement>('[role="tab"]')[next]
                ?.focus();
            event.preventDefault();
        }
    }
}
